




















import { Component, Vue, Prop } from "vue-property-decorator";
import BScroll from "better-scroll";

@Component
export default class PageContent extends Vue {
  @Prop()
  pulldownrefresh!: Function;
  @Prop()
  list!: Array<object>;
  @Prop()
  pullupconcat!: Function;
  @Prop()
  totalCount!: number;
  @Prop()
  openPulldown!: boolean;
  
  pullDownMsg: string = "下拉刷新";
  pullUpMsg: string = "上拉查看更多拼团";
  isPullingDown: boolean = false;
  scroll: any;

  mounted() {
    let that = this;
    this.$nextTick(() => {
      this.scroll = new BScroll((this.$refs as any).wrapper, {
        click: true,
        probeType: 1,
        pullDownRefresh: this.openPulldown
          ? {
              threshold: 40,
              stop: 30
            }
          : false,
        pullUpLoad: {
          threshold: 40
        }
      });

      if (this.openPulldown) {
        this.scroll.on("scrollStart", (pos: any) => {
          this.isPullingDown = false;
          this.pullDownMsg = "下拉刷新";
        });

        this.scroll.on("scroll", (pos: any) => {
          if (pos.y > 40) {
            // 下拉刷新
            this.pullDownMsg = "释放立即刷新";
          }
        });

        this.scroll.on("pullingDown", () => {
          this.isPullingDown = true;

          this.pulldownrefresh().then(() => {
            this.scroll.finishPullDown();
            this.scroll.refresh();
          });
        });
      }

      this.scroll.on("pullingUp", () => {
        if (this.list.length !== this.totalCount) {
          this.pullUpMsg = "加载中";
          this.pullupconcat().then(() => {
            this.scroll.finishPullUp();
            this.pullUpMsg = "上拉查看更多拼团";
            this.scroll.refresh();
          });
        }
      });
    });
  }
}
